import { isEmpty, last, map, noop } from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash/fp';
import { Empty } from '@mews-commander/ui';
import { ApplicationState, SearchResult } from '@mews-commander/types';
import { SearchType } from '@mews-commander/enums';
import { ClickAwayProps, Divider, OpenableOverlay, withClickAway } from '@optimus-web/core';
import { getResultSections } from '../selectors';
import ResultSectionTitle from './ResultSectionTitle';
import Result from './Result';
import MoreButton from './MoreButton';

interface OwnProps {
    results: SearchResult[];
    searchProps: {
        searchTerm: string;
        searchTypes: SearchType[];
        scope: string;
        except?: string[];
        newEntity?: boolean;
    };
    hidden?: boolean;
    showSectionTitle?: boolean;
    onResultClick?: $TSFixMeFunction;
    onMoreClick?: $TSFixMeFunction;
    anchorElement: HTMLElement;
    showInvoiceableTag: boolean;
    handleClickAway: () => void;
}

type State = $TSFixMe;

type Props = OwnProps & typeof ResultDrawer.defaultProps & ClickAwayProps;

class ResultDrawer extends Component<Props, State> {
    static defaultProps = {
        showSectionTitle: true,
        onResultClick: noop,
        onMoreClick: noop,
    };

    state = {
        selected: {},
    };

    overlay: HTMLDivElement | null = null;

    UNSAFE_componentWillReceiveProps(nextProps: Props): void {
        if (!nextProps.hidden && this.props.hidden) {
            this.props.registerClickAway({
                roots: [() => nextProps.anchorElement, () => this.overlay],
                handler: this.props.handleClickAway,
            });
        }

        if (nextProps.hidden && !this.props.hidden) {
            this.props.deregisterClickAway();
        }
    }

    getSelectedResult = () => {
        if (isEmpty(this.state.selected)) {
            return null;
        }

        // @ts-expect-error $TSFixMeError: Property 'sectionIndex' does not exist on type '{}'.
        const { sectionIndex, index } = this.state.selected;
        // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
        return this.props.results[sectionIndex].items[index];
    };

    clearSelectedResult = () => {
        this.setState({ selected: {} });
    };

    handleResultClick = (result: $TSFixMe) => {
        this.props.onResultClick(result);
    };

    handleMoreClick = (type: $TSFixMe) => {
        this.props.onMoreClick(type);
    };

    navigateDown = () => {
        if (this.props.hidden || isEmpty(this.props.results)) {
            return;
        }

        if (isEmpty(this.state.selected)) {
            this.setState({
                selected: {
                    sectionIndex: 0,
                    index: 0,
                },
            });

            return;
        }

        // @ts-expect-error $TSFixMeError: Property 'sectionIndex' does not exist on type '{}'.
        let { sectionIndex, index } = this.state.selected;
        ++index;

        // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
        if (index === this.props.results[sectionIndex].items.length) {
            index = 0;
            sectionIndex = (sectionIndex + 1) % this.props.results.length;
        }

        this.setState({ selected: { sectionIndex, index } });
    };

    navigateUp = () => {
        if (this.props.hidden || isEmpty(this.props.results)) {
            return;
        }

        if (isEmpty(this.state.selected)) {
            const lastSection = last(this.props.results);
            this.setState({
                selected: {
                    sectionIndex: this.props.results.length - 1,
                    // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
                    index: lastSection.items.length - 1,
                },
            });

            return;
        }

        // @ts-expect-error $TSFixMeError: Property 'sectionIndex' does not exist on type '{}'.
        let { sectionIndex, index } = this.state.selected;
        --index;

        if (index < 0) {
            sectionIndex = sectionIndex === 0 ? this.props.results.length - 1 : sectionIndex - 1;
            // @ts-expect-error $TSFixMeError: Object is possibly 'undefined'.
            index = this.props.results[sectionIndex].items.length - 1;
        }

        this.setState({ selected: { sectionIndex, index } });
    };

    renderResultsSection = (section: $TSFixMe, sectionIndex: $TSFixMe, showInvoiceableTag: boolean) => {
        const ret = [];

        if (sectionIndex > 0) {
            ret.push(<Divider key={`${section.type}divider`} />);
        }

        if (this.props.showSectionTitle || this.props.results.length > 1) {
            ret.push(<ResultSectionTitle key={section.type} type={section.type} />);
        }

        const results = map(section.items, (result, index) => (
            <Result
                key={section.type + index}
                focused={
                    sectionIndex === (this.state.selected as $TSFixMe).sectionIndex &&
                    index === (this.state.selected as $TSFixMe).index
                }
                onClick={this.handleResultClick}
                result={result}
                showInvoiceableTag={showInvoiceableTag}
            />
        ));
        ret.push(...results);

        if (section.hasMore) {
            ret.push(
                <MoreButton
                    key={`${section.type}more`}
                    type={section.type}
                    isLoading={section.isFetching}
                    onClick={this.handleMoreClick}
                />
            );
        }

        return ret;
    };

    render() {
        const { results, hidden, anchorElement, showInvoiceableTag } = this.props;

        return (
            <OpenableOverlay
                anchorElement={() => anchorElement}
                sizeToAnchor
                opened={!hidden}
                innerRef={(element) => (this.overlay = element)}
            >
                <>
                    {isEmpty(results) ? (
                        <Empty padded />
                    ) : (
                        map(results, (s, index) => this.renderResultsSection(s, index, showInvoiceableTag))
                    )}
                </>
            </OpenableOverlay>
        );
    }
}

export default connect<Pick<OwnProps, 'results'>, {}, Omit<OwnProps, 'results'>, ApplicationState>(
    (state, { searchProps }) => ({
        results: getResultSections(state, searchProps),
    }),
    null,
    null,
    {
        forwardRef: true,
        areStatePropsEqual: isEqual,
    }
)(withClickAway(ResultDrawer));
